export default __webpack_public_path__ + "static/media/download.e67f20e3.svg";